const RPC = window.ethereum;
export default RPC;